var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".toast-overlay[data-v-20496a5d] {\n  position: fixed;\n  top: 24px;\n  right: 24px;\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  animation: toast-slide-in 0.3s ease;\n  font-size: 14px;\n  font-weight: 500;\n}\n.toast-success[data-v-20496a5d] {\n  background: #ecfdf3;\n  color: #027a48;\n  border: 1px solid #a6f4c5;\n}\n.toast-error[data-v-20496a5d] {\n  background: #fef3f2;\n  color: #b42318;\n  border: 1px solid #fecdca;\n}\n.toast-icon[data-v-20496a5d] {\n  flex-shrink: 0;\n}\n@keyframes toast-slide-in {\n  from {\n    opacity: 0;\n    transform: translateX(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "ToastNotification",
  props: {
    message: { type: String, default: "" },
    type: { type: String, default: "success" },
    duration: { type: Number, default: 3000 }
  },
  data: function data() {
    return {
      visible: false,
      timer: null
    };
  },
  methods: {
    show: function show(msg) {
      var self = this;
      self.message = msg || self.message;
      self.visible = true;
      if (self.timer) clearTimeout(self.timer);
      self.timer = setTimeout(function () {
        self.visible = false;
      }, self.duration);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"toast-overlay",class:'toast-' + _vm.type},[_c('span',{staticClass:"toast-icon"},[(_vm.type === 'success')?_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"}},[_c('rect',{attrs:{"width":"20","height":"20","rx":"10","fill":"#00C167"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6 10l3 3 5-5","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]):_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"}},[_c('rect',{attrs:{"width":"20","height":"20","rx":"10","fill":"#D80027"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7 7l6 6M13 7l-6 6","stroke":"white","stroke-width":"2","stroke-linecap":"round"}})])]),_vm._v(" "),_c('span',{staticClass:"toast-message"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-20496a5d"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-20496a5d", __vue__options__)
  } else {
    hotAPI.reload("data-v-20496a5d", __vue__options__)
  }
})()}